/* eslint-disable */
export enum RiskLevels {
  Low,
  Increasing,
  High,
  Dependent
}
/* eslint-enable */
